import { combineReducers } from "redux";
import { customizerReducer } from "./customizer/customizerReducer";
import { customerPolicyDetailsReducer } from "./customerPolicyDetails/customerPolicyDetailsReducer";
import { initialStoreState, IStoreState } from "./initialStoreState";
import { insurerReducer } from "./insurer/insurerReducer";
import { messageReducer } from "./messages/messagesReducer";
import { customerReducer } from "./customer/customerReducer";
import { underWriterReducer } from "./underWriter/underWriterReducer";
import { csioCompanyReducer } from "./csioCompany/csioCompanyReducer";
import { branchOfficeReducer } from "./branchOffice/branchOfficeReducer";
import { brokerCodeReducer } from "./brokerCode/brokerCodeReducer";
import { subInsurerReducer } from "./subInsurer/subInsurerReducer";
import { policyCommissionReducer } from "./policyCommission/policyCommissionReducer";
import { insurerContactsReducer } from "./insurerContacts/insurerContactsReducer";
import { businesspolicBasicDetailsReducer } from "./businessPolicy/businessPolicyBasicDetails/businessPolicyBasicDetailsReducer";
import { businessPolicyUnderWritingReducer } from "./businessPolicy/businessPolicyUnderWriting/businePolicyUnderWritingReducer";
import { businessPolicyCoverageReducer } from "./businessPolicy/businessPolicyCoverage/businesPolicyCoverageReducer";
import { coverageFromQuoteReducer } from "./businessPolicy/businessPolicyCoverage/coverageFromQuoteReducer";
import { businessPolicyCoverageExclusionsReducer } from "./businessPolicy/businessPolicyCoverageExclusions/businessPolicyCoverageExclusionsReducer";
import { businessPolicyRiskLocationReducer } from "./businessPolicy/buisenessPolicyRiskLocation/businessPolicyRiskLocationReducer";
import { businessPolicyFineArtReducer } from "./businessPolicy/businessPolicyFineArt/businessPolicyFineArtReducer";
import { businessPolicyToolFloaterReducer } from "./businessPolicy/businessPolicyToolFloater/businessPolicyToolFloatreReducer";
import { businessPolicyEquipmentReducer } from "./businessPolicy/businessPolicyEquipment/businessPolicyEquipmentReducer";
import { businessPolicyAdditionalReducer } from "./businessPolicy/businessPolicyAdditional/businessPolicyAdditionalReducer";
import { businessPolicyInterestedReducer } from "./businessPolicy/businessPolicyInterested/businessPolicyInterestedReducer";
import { businessPolicySubscriptionReducer } from "./businessPolicy/businessPolicySubscription/businessPolicySubscriptionReducer";
import { businessPolicUnderLyingReducer } from "./businessPolicy/businessPolicyUnderLyingInsurance/businessPolicyUnderLyingInsuranceReducer";
import { commonReducer } from "./common/commonReducer";
import { AutomobileGaragePlatesReducer } from "./automobileGaragePlates/automobileGaragePlatesReducer";
import { AutomobileVehicleReducer } from "./automobileVehicle/automobileVehicleReducer";
import { automobilespolicBasicDetailsReducer } from "./automobileBasicDetails/automobileBasicDetailsReducer";
import { AutomobileCSVReducer } from "./automobileCSV/automobileCSVReducer";
import { AutomobileDriverReducer } from "./automobileDriver/automobileDriverReducer";
import { AutomobileScheduleReducer } from "./automobileSchedule/automobileScheduleReducer";
import { habitationalBasicDetailsReducer } from "./habitationalPolicy/habitationalBasicDetails/habitationalBasicDetailsReducer";
import { HabitationalClaimReducer } from "./habitationalPolicy/habitationalClaim/habitationalCLaimReducer";
import { UserProfileReducer } from "./UserProfileList/userProfileReducer";
import { tasksReducer } from "./tasks/tasksReducer";
import { tasksCalenderReducer } from "./tasksCalender/tasksCalenderReducer";
import { generalChangeReducer } from "./generalChange/generalChangeReducer";
import { taskDriverReducer } from "./TaskReducer/Driver/driverReducer";
import { taskVehicleReducer } from "./TaskReducer/Vehicle/taskVehicleReducer";
import { taskGaragePlateReducer } from "./TaskReducer/GaragePlate/garagePlateReducer";
import { taskInterestedPartyReducer } from "./TaskReducer/InterestedParty/interestedPartyReducer";
import { taskLessorReducer } from "./TaskReducer/Lessor/lessorReducer";
import { taskRiskLocationReducer } from "./TaskReducer/RiskLocation/taskriskLocationReducer";
import { opportunitesReducer } from "./opportunites/opportunitesReducer";
import { businessPolicyRestrutantReducer } from "./businessPolicy/businessPolicyRestrutant/businessPolicyRestrutantReducer";
import { businessPolicyContractorReducer } from "./businessPolicy/businessPolicyContractor/businessPolicyContractorReducer";
import { businessPolicyHistoryReducer } from "./businessPolicy/businessPolicyHistory/businessPolicyHistoryReducer";
import { businessPolicyMarketingReducer } from "./businessPolicy/businessPolicyMarketing/businessPolicyMarketingReducer";
import { lifeInsuranceBasicDetailsReducer } from "./lifeInsurancePolicy/lifeInsuranceBasicDetail/lifeInsuranceBasicDetailReducer";
import { automobilePolicyMarketingReducer } from "./automobileMarketingHistory/automobileMarketingHistoryReducer";
import { automobileCertificatesReducer } from "./automobileCertificates/automobileCertificatesReducer";
import { AutomobileApplicationReducer } from "./automobileApplication/automobileApplicationReducer";
import { habitationalApplicationReducer } from "./habitationalPolicy/habitationalApplication/habitationalApplicationReducer";
import { lifeInsurancePoliciesReducer } from "./lifeInsurancePolicy/lifeInsurancePolicies/lifeInsurancePoliciesReducer";
import { lifeInsuranceComplianceCheckListReducer } from "./lifeInsurancePolicy/lifeInsurancePolicyComplianceCheckList/lifeInsurancePolicyComplianceCheckListReducer";
import { lifeInsurancePolicyExistingPropertyReducer } from "./lifeInsurancePolicy/lifeInsurancePolicyExistingProperty/lifeInsurancePolicyExistingPropertyReducer";
import { lifeInsurancePolicyFamilyTreeReducer } from "./lifeInsurancePolicy/lifeInsurancePolicyFamilyTree/lifeInsurancePolicyFamilyTreeReducer";
import { automobileSupplementReducer } from "./automobileSupplement/automobileSupplementReducer";
import { lifeInsuranceCoverageNeedReducer } from "./lifeInsurancePolicy/lifeInsuranceCoverageNeed/lifeInsuranceCoverageNeedReducer";
import { lifeInsuranceRidersReducer } from "./lifeInsurancePolicy/lifeInsuranceRiders/lifeInsuranceRidersReducer";
import { AutomobileGarageApplicationReducer } from "./automobileGarageApplication/automobileGarageApplicationReducer";
import { CommAutomobilespolicBasicDetailsReducer } from "./commAutoPolicy/commAutoBasicDetails/commAutoBasicDetailsReducer";
import { CommAutomobileCertificatesReducer } from "./commAutoPolicy/commAutoCertificates/commAutoCertificatesReducer";
import { CommAutomobileCSVReducer } from "./commAutoPolicy/commAutoCSV/commAutoCSVReducer";
import { CommAutomobileDriverReducer } from "./commAutoPolicy/commAutoDriver/commAutoDriverReducer";
import { CommAutomobileGaragePlatesReducer } from "./commAutoPolicy/commAutoGaragePlates/commAutoGaragePlatesReducer";
import { CommAutomobilePolicyMarketingReducer } from "./commAutoPolicy/commAutoMarketingHistory/commAutoMarketingHistoryReducer";
import { CommAutomobileScheduleReducer } from "./commAutoPolicy/commAutoSchedule/commAutoScheduleReducer";
import { CommAutomobileSupplementReducer } from "./commAutoPolicy/commAutoSupplement/commAutoSupplementReducer";
import { CommAutomobileVehicleReducer } from "./commAutoPolicy/commAutoVehicle/commAutoVehicleReducer";
import { riskProfileReducer } from "./commAutoPolicy/commAutoRiskProfile/commAutoRiskProfileReducer";
import { riskProfileV2Reducer } from "./commAutoPolicy/commAutoRiskProfile/commAutoRiskProfileV2Reducer";
import { iftaImportReducer } from "./commAutoPolicy/commAutoRiskProfile/iftaImportReducer";
import { insuranceReducer } from "./insuranceReports/insuranceReportsReducer";
import { applicationReducer } from "./allApplications/allApplicationsReducer";
import { templateReducer } from "./templates/templateReducer";
import { bindersReducer } from "./Binder/binderReducer";
import { MarketingsReducer } from "./marketing/marketingReducer";
import { NewRemarketReducer } from "./NewRemarket/NewRemarketReducer";
import { IntrestedPartiesReducer } from "./InterestedParties/IntrestedPartiesReducer";
import { AdditionalInterestReducer } from "./AdditionalInterest/additionalInterestReducer";
import { tasksPaymentMethodsReducer } from "./taskPaymentMethod/taskPaymentMethodsReducer";
import { taskUrgentTransactionsReducer } from "./taskUrgentTransactions/taskUrgentTransactionsReducer";
import { tasksBoardReducer } from "./taskBoard/taskBoardReducer";
import { securityReducer } from "./security/securityReducer";
import legalsReducer from "./legals/legalsReducer";
import { noticesReducer } from "./notices/noticesReducer";
import eDocsReducer from "./eDocs/eDocsReducer";
import { notesReducer } from "./notes/notesReducer";
import { AccountingCompanyInformationReducer } from "./Accounting/CompanyInformation/companyInformationReducer";
import { AccountingTaxInformationReducer } from "./Accounting/TaxInformation/taxInformationReducer";
import { AccountingGLAccountsReducer } from "./Accounting/GLAccounts/glAccountsReducer";
import { ChartsOfAccountsReducer } from "./Accounting/ChartsOfAccounts/ChartsOfAccountsReducer";
import { appFormReducer } from "./appForm/appFormReducer";
import { AccountingIInteracEmailTransferReducer } from "./Accounting/InteracEmailTransfer/InteracEmailTransferReducer";
import { AccountingEftReducer } from "./Accounting/Eft/EftReducer";
import { AccountingReceivableReducer } from "./Accounting/Recievable/ReceivableReducer";
import { AccountingCompanyDetailReducer } from "./Accounting/CompanyDetail/CompanyDetailReducer";
import { AccountingCompanyOnboardingReducer } from "./Accounting/CompanyOnboarding/CompanyOnboardingReducer";
import { AccountingTaxInfoReducer } from "./Accounting/TaxInfo/TaxInfoReducer";
import { AccountingTransactionsReducer } from "./Accounting/Transactions/TransactionsReducer";
import { AccountingInformationReducer } from "./Accounting/AccountingInformation/AccountingInformationReducer";
import { AccountingInvoiceInformationReducer } from "./Accounting/InvoiceInformation/InvoiceInformationReducer";
import { AccountingBankAccountReducer } from "./Accounting/BankAccount/BankAccountReducer";
import { AccountingChequeReducer } from "./Accounting/Cheque/ChequeReducer";
import { AccountingAccountsPayableReducer } from "./Accounting/AccountsPayable/AccountsPayableReducer";
import { AccountingPaymentAccountsRecievableReducer } from "./Accounting/PaymentAccountsRecievable/PaymentAccountsRecievableReducer";
import { AccountingRecievableTrustReducer } from "./Accounting/RecievableTrust/RecievableTrustReducer";
import { AccountingAccountsPayableChequeReducer } from "./Accounting/AccountsPayableCheque/AccountsPayableChequeReducer";
import { AccountingVendorReducer } from "./Accounting/Vendor/VendorReducer";
import { AccountingInvoiceTemplateReducer } from "./Accounting/Template/TemplateReducer";
import { AccountingTransactioTypeReducer } from "./Accounting/TransactionType/TransactionTypeReducer";
import { AccountingTransactioDescriptionReducer } from "./Accounting/TransactionDescription/TransactionDescriptionReducer";
import { AccountingBillReducer } from "./Accounting/Bill/BillReducer";
import { AccountingBillTemplateReducer } from "./Accounting/BillTemplate/BillTemplateReducer";
import { AccountingBillPaymentPayableReducer } from "./Accounting/BillPaymentPayable/BillPaymentPayableReducer";
import { g4SignDocumentsReducer } from "./g4SignDocuments/g4SignDocumentsReducer";
import { borkerContactsReducer } from "./brokerContacts/brokerContactsReducer";
import { supportTicketsReducer } from "./supportTickets/supportTicketsReducer";
import { allBindersReducer } from "./AllBinders/allbinderReducer";
import { renewalsReducer } from "./renewals/renewalsReducer";
import { emailStatisticsReducer } from "./emailStatistics/emailStatisticsReducer";
import { AutomobileAlbertaApplicationReducer } from "./automobileAlbertaApplication/automobileAlbertaApplicationReducer";
import { utilityReducer } from "./utility/utilityReducer";
import { csioReducer } from "./csio/csioReducer";
import { automationReducer } from "./automation/automationReducer";
import { emailSequencesReducer } from "./emailSequences/emailSequencesReducer";
import { sequenceContactListsReducer } from "./sequenceContactLists/sequenceContactListsReducer";
import { AutomobileCSIOApplicationReducer } from "./automobileCSIOApplication/automobileCSIOApplicationReducer";

import { HabitationalCSIOApplicationReducer } from "./habitationalPolicy/habitationalCsioApplication/habitationalCsioApplicationReducer";
import { equipmentReducer } from "./equipment/equipmentReducer";
import { csioEdocsReducer } from "./csioEdocs/csioEdocsReducer";
import { CommAutoCSIOApplicationReducer } from "./commAutoPolicy/commAutoCsioApplication/commAutoCsioApplicationReducer";
import { HabitationalRiskLocationReducer } from "./habitationalPolicy/habitationalRiskLocation/habitationalRiskLocationReducer";
import { HabitationalInterestedPartyReducer } from "./habitationalPolicy/habitationalAdditionalInterest/habitationalAdditionalReducer";
import { HabitationalInterestedReducer } from "./habitationalPolicy/habitationalInterestedParty/habitationalInterestedReducer";
import { HabitationalCoveragesReducer } from "./habitationalPolicy/habitationalCoverages/habitatioanalCoveragesReducer";
import { HabitationalPolicyChangeReqReducer } from "./habitationalPolicy/habitationalPolicyChangeRequest/habitationalPolicyChangeReqReducer";
import { activityReducer } from "./activity/activityReducer";
import { expressionTransformationReducer } from "./expressionTransformation/expressionTransformationReducer";
import { AccountingSystemGLAccountReducer } from "./Accounting/SystemGLAccount/SystemGLAccountReducer";
import { AccountingReportsReducer } from "./Accounting/Reports/ReportsReducer";
import { csioCronReducer } from "./csioCron/csioCronReducer";
import { AutomobileCSIOEDIApplicationReducer } from "./automobileCSIOEDIApplication/automobileCSIOEdiApplicationReducer";
import { HabitationalPolicyFormReducer } from "./habitationalPolicy/HabitationalPolicyForm/HabitationalPolicyFormReducer";
import { reconciliationReducer } from "./reconciliation/reconciliationReducer";
import { HabitationalCSIOEDIApplicationReducer } from "./habitationalPolicy/habitationalCSIOEDIApplication/habitationalCSIOEDIApplicationReducer";
import { AllCustomersDetailsReducer } from "./allCustomers/allCustomersReducer";
import { AllPoliciesReducer } from "./allPolicies/PoliciesReducer";
import { AccountingTaxReducer } from "./Accounting/Tax/TaxReducer";
import { controlLogReducer } from "./ControlLog/controlLogReducer";
import { envConfigReducer } from "./envConfig/envConfigReducer";
import { AccountingDashboardReducer } from "./accountingDashboard/accountingDashboardReduer";
import { commAutoPolicyFormsReducer } from "./commAutoPolicy/commAutoPolicyForms/commAutoPolicyFormsReducer";
import { AutomobilePolicyFormsReducer } from "./automobilePolicyForms/automobilePolicyFormReducer";
import { commAutoAllApplicationReducer } from "./commAutoPolicy/commAutoAllApplications/commAutoAllApplicationsReducer";
import { businessPolicyFormsReducer } from "./businessPolicy/businessPolicyForms/businessPolicyFormReducer";
import { GroupPlansReducer } from "./GroupPlans/groupPlansReducer";
import { AutomobileQuoteReducer } from "./automobileQuote/automobileQuoteReducer";
import { AutomobileInsuranceLapseReducer } from "./automobileInsuranceLapse/automobileInsuranceLapseReducer";
import { AutomobileFraudMisRepresentReducer } from "./automobileFraudMisRepresent/automobileFraudMisRepresentReducer";
import { QuoteSettingsReducer } from "./QuoteSettings/quoteSettingsReducer";
import { oldBusinessTrackerReducer } from "./OldBusinessTracker/oldBusinessTrackerReducer";
import { oldInsuranceReportsReducer } from "./OldInsuranceReport/oldInsuranceReportReducer";
import { HabitationalPropertyScheduleReducer } from "./habitationalPolicy/habitationalPropertySchedule/habitationalPropertyScheduleReducer";
import { csioEDIReducer } from "./csioEDI/csioEDIReducer";
import { ediXmlTrackingReducer } from "./ediXmlTracking/ediXmlTrackingReducer";
import { businessPolicyChangeReducer } from "./businessPolicy/businessPolicyChange/businessPolicyChangeReducer";
import { businessPolicySOVReducer } from "./businessPolicy/businessPolicySOV/businessPolicySOVReducer";
import { businessPolicyBusinessInterruptionReducer } from "./businessPolicy/businessPolicyBusinessInterruption/businessPolicyBusinessInterruptionReducer";
import { aiReconciliationReducer } from "./aiReconciliation/aiReconciliationReducer";
import { GeneralLedgerReducer } from "./Accounting/GeneralLedger/GeneralLedgerReducer";
import { AutomobilePolicyChangeReqReducer } from "./automobilePolicyChangeReq/automobilePolicyChangeReqReducer";
import { policyChangeRequestReducer } from "./PolicyChangeRequest/policyChangeRequestReducer";
import { AddressHistoryReducer } from "./habitationalPolicy/habitationalAddressHistory/habitationalAddressHistoryReducer";
import { commAutoPolicyChangeReqReducer } from "./commAutoPolicy/commAutoPolicyChangeRequest/automobilePolicyChangeReqReducer";
import { HabitationalQuoteReducer } from "./habitationalPolicy/habitationalQuote/habitationalQuoteReducer";
import { policyCommonReducer } from "./policyCommon/policyCommonReducer";
import { CallAgencyBillorDirectReducer } from "./Accounting/AccountingReports/AccountingReportsReducer";
import { quoteRequestReducer } from "./Quote/quoteReducer";
import { customerStatementReportReducer } from "./Accounting/CustomerStatementReport/CustomerStatementReportReducer";
import { testOneReducer } from "./Accounting/TestOne/testOneReducer";
import { testTwoReducer } from "./Accounting/TestTwo/testTwoReducer";
import { AccountingBillTransactioTypeReducer } from "./Accounting/BillTransactionType/BillTransactionTypeReducer";
import { claimsReducer } from "./claims/claimsReducer";
import { operatingStatementsReducer } from "./Accounting/operatingStatements/OpeartingStatementsReducer";
import { aiProjectsReducer } from "./aiProjects/aiProjectsReducer";
import { userMappingReducer } from "./userMapping/userMappingReducer";
import { AccountingJeTypeAndEntryReducer } from "./Accounting/JeTypeAndEntry/JeTypeAndEntryReducer";
import { balanceSheetStatementsReducer } from "./Accounting/BalanceSheetStatements/BalanceSheetStatementsReducer";
import { glAgingReportReducer } from "./Accounting/GLAgingReport/GLAgingReportReducer";
import { emailsReducer } from "./emails/EmailsReducer";
import { fiscalPeriodsReducer } from "./Accounting/FiscalPeriods/FiscalPeriodsReducer";
import { glMonthlySummaryReducer } from "./Accounting/GLMonthlySummary/GLMonthlySummaryReducer";
import { glFiscalYearCloseReducer } from "./Accounting/GLFiscalYearClose/GLFiscalYearCloseReducer";
import { seedBalancesReducer } from "./Accounting/SeedBalances/SeedBalancesReducer";
import { glSummaryReconcileReducer } from "./Accounting/GLSummaryReconcile/GLSummaryReconcileReducer";
import { premiumComparisonReducer } from "./premiumComparison/premiumComparisonReducer";
import { RIBOFormsReducer } from "./Accounting/RIBOForms/RIBOFormsReducer";
import { AccountingPaymentBulkAccountsRecievableReducer } from "./Accounting/PaymentBulkAccountsRecievable/PaymentBulkAccountRecievableReducer";
import { AccountingPhysicalDefaultCommissionReducer } from "./Accounting/PhysicalDefaultCommission/PhyscicalDefaultCommissionReducer";
import { bankCreditDebitReducer } from "./Accounting/BankDebitCredit/BankDebitCreditReducer";
import { mpoiReducer } from "./MPOI/MpoiReducer";
import { AccountingCreditCardReducer } from "./Accounting/CreditCards/CreditCardReducer";
import { TrialBalanceReducer } from "./Accounting/TrialBalance/TrialBalanceReducer";
import { whatsappTemplateReducer } from "./whatsappTemplate/whatsappTemplateReducer";
import { subscriptionPlanReducer } from "./subscription/subscriptionReducer";
import { quickReplyTemplateReducer } from "./quickReplyTemplates/quickReplyTemplateReducer";
import { actionItemReducer } from "./actionItems/actionItem.reducer";
import { orgEnvConfigReducer } from "./orgEnvConfig/orgEnvConfigReducer";
import chatbotReducer from "./chatbot/chatbotReducer";
import { myCommissionReportsReducer } from "./myCommissionReport/myCommissionReportsReducer";
import { leadsReducer } from "./leads/leadsReducer";
import { leadApplicationsReducer } from "./leads/leadApplications/leadApplicationsReducer";
import { leadHabitationalApplicationReducer } from "./leads/leadHabitationalApplication/leadHabitationalApplicationState";
import { leadAutoApplicationReducer } from "./leads/leadAutoApplication/leadAutoApplicationReducer";
import { MasterDropdownsReducer } from "./MasterDropdowns/MasterDropdownsReducer";
import { ButtonRoleVisibilityReducer } from "./ButtonRoleVisibility/ButtonRoleVisibilityReducer";
import { CustomFormFieldsReducer } from "./CustomFormFields/CustomFormFieldsReducer";
import { myRenewalsReducer } from "./myRenewals/myRenewalsReducer";
import { importBulkPaymentBillReducer } from "./Accounting/importbulkPaymnetBill/importBulkPaymentBillReducer";
import { notificationReducer } from "./notification/notificationReducer";
import { outlookReducer } from "./outlook/outlookSlice";
import { aiChatReducer } from "./aiChat/aiChatSlice";
import dashboardReducer from "./dashboard/dashboardSlice";
import { businessCertificateofInsuranceReducer } from "./businessPolicy/businessCertificateofInsurance/businessCertificateofInsuranceReducer";
import { automobileCertificateofInsuranceReducer } from "./automobileCertificateofInsurance/automobileCertificateofInsuranceReducer";
import { commAutoCertificateofInsuranceReducer } from "./commAutoCertificateofInsurance/commAutoCertificateofInsuranceReducer";
import { commAutoDriverProfileReducer } from "./commAutoDriverProfile/commAutoDriverProfileReducer";
import { operationalUpdatesReducer } from "./operationalUpdates/operationalUpdatesSlice";
import { signatureReducer } from "./signature/signatureSlice";
import { accessLogsReducer } from "./accessLogs/accessLogsSlice";
import { genAiKnowledgeBaseReducer } from "./documentTraining/documentTrainingSlice";
import { RecurringInvoiceReducer } from "./Accounting/RecurringInvoice/RecurringInvoiceReducer";
import { policyEmailComposeReducer } from "./policyEmailCompose/policyEmailComposeReducer";
import globalMessagesReducer from "./globalMessages/globalMessagesSlice";
import { requestedUserNameReducer } from "./requestedUserName/requestedUserNameReducer";
import { certificateOfInsuranceReducer } from "./certificateOfInsurance/certificateOfInsuranceReducer";
import { changeHistoryReducer } from "./changeHistory/changeHistorySlice";
import { vinDecoderReducer } from "./vinDecoder/vinDecoderReducer";
import plInsightsReducer from "./plInsights/plInsightsSlice";
import dashboardSettingsReducer from "./dashboardSettings/dashboardSettingsSlice";
import { phoneReducer } from "./phone/phoneSlice";
import { mirtapbxCallLogReducer } from "./mirtapbxCallLog";
import { mirtapbxCallContextReducer } from "./mirtapbxCallContext";
import { genAiReducer } from "./genAi/genAiReducer";
import { messageSequenceReducer } from "./MessageSequence/MessageSequenceReducer";
import { agentToolsReducer } from "./AgentTools/AgentToolsReducer";
import { webrtcReducer } from "./webrtc/webrtcSlice";
import { pbsQuoteReducer } from "./pbsQuote/pbsQuoteSlice";

const appReducer = combineReducers({
  customizerReducer: customizerReducer,
  borkerage: combineReducers({
    insurer: insurerReducer,
    subInsurer: subInsurerReducer,
    branchOffice: branchOfficeReducer,
    brokerCode: brokerCodeReducer,
    underwriter: underWriterReducer,
    csioCompany: csioCompanyReducer,
    insurerContacts: insurerContactsReducer,
    policyCommission: policyCommissionReducer,
    intrestedParties: IntrestedPartiesReducer,
    additionalInterest: AdditionalInterestReducer,
    brokerContacts: borkerContactsReducer,
    equipment: equipmentReducer,
    groupPlans: GroupPlansReducer,
  }),
  allpolicies: AllPoliciesReducer,
  allcustomers: AllCustomersDetailsReducer,
  customer: customerReducer,
  customerPolicyDetails: customerPolicyDetailsReducer,
  message: messageReducer,
  business: combineReducers({
    basicDetails: businesspolicBasicDetailsReducer,
    underwriting: businessPolicyUnderWritingReducer,
    coverage: businessPolicyCoverageReducer,
    coverageFromQuote: coverageFromQuoteReducer,
    coverageExclusions: businessPolicyCoverageExclusionsReducer,
    riskLocation: businessPolicyRiskLocationReducer,
    fineArt: businessPolicyFineArtReducer,
    toolFloater: businessPolicyToolFloaterReducer,
    equipment: businessPolicyEquipmentReducer,
    interested: businessPolicyInterestedReducer,
    additional: businessPolicyAdditionalReducer,
    subscription: businessPolicySubscriptionReducer,
    underLying: businessPolicUnderLyingReducer,
    restrutant: businessPolicyRestrutantReducer,
    contractor: businessPolicyContractorReducer,
    history: businessPolicyHistoryReducer,
    marketing: businessPolicyMarketingReducer,
    policyForms: businessPolicyFormsReducer,
    policyChange: businessPolicyChangeReducer,
    certifcateofInsurance: businessCertificateofInsuranceReducer,
    sovTab: businessPolicySOVReducer,
    businessInterruption: businessPolicyBusinessInterruptionReducer,
  }),
  automobile: combineReducers({
    basicDetails: automobilespolicBasicDetailsReducer,
    garagePlate: AutomobileGaragePlatesReducer,
    vehicle: AutomobileVehicleReducer,
    csv: AutomobileCSVReducer,
    driver: AutomobileDriverReducer,
    schedule: AutomobileScheduleReducer,
    marketing: automobilePolicyMarketingReducer,
    certificates: automobileCertificatesReducer,
    allApplications: AutomobileApplicationReducer,
    albertaApplication: AutomobileAlbertaApplicationReducer,
    csioapplication: AutomobileCSIOApplicationReducer,
    edi: AutomobileCSIOEDIApplicationReducer,
    policyChangeReq: AutomobilePolicyChangeReqReducer,
    supplement: automobileSupplementReducer,
    garageApplication: AutomobileGarageApplicationReducer,
    policyForms: AutomobilePolicyFormsReducer,
    quote: AutomobileQuoteReducer,
    insuranceLapse: AutomobileInsuranceLapseReducer,
    fraudMisRepresent: AutomobileFraudMisRepresentReducer,
    certificateOfInsurance: automobileCertificateofInsuranceReducer,
  }),
  commAuto: combineReducers({
    basicDetails: CommAutomobilespolicBasicDetailsReducer,
    csioapplication: CommAutoCSIOApplicationReducer,
    certificates: CommAutomobileCertificatesReducer,
    csv: CommAutomobileCSVReducer,
    driver: CommAutomobileDriverReducer,
    garagePlate: CommAutomobileGaragePlatesReducer,
    marketing: CommAutomobilePolicyMarketingReducer,
    schedule: CommAutomobileScheduleReducer,
    supplement: CommAutomobileSupplementReducer,
    vehicle: CommAutomobileVehicleReducer,
    policyForms: commAutoPolicyFormsReducer,
    allApplications: commAutoAllApplicationReducer,
    policyChangeReq: commAutoPolicyChangeReqReducer,
    certificateOfInsurance: commAutoCertificateofInsuranceReducer,
    driverProfile: commAutoDriverProfileReducer,
    riskProfile: riskProfileReducer,
    riskProfileV2: riskProfileV2Reducer,
    iftaImport: iftaImportReducer,
  }),
  habitational: combineReducers({
    basicDetails: habitationalBasicDetailsReducer,
    claimDetails: HabitationalClaimReducer,
    riskLocation: HabitationalRiskLocationReducer,

    applications: habitationalApplicationReducer,
    csioapplication: HabitationalCSIOApplicationReducer,
    edi: HabitationalCSIOEDIApplicationReducer,
    additional: HabitationalInterestedPartyReducer,
    interested: HabitationalInterestedReducer,
    coverages: HabitationalCoveragesReducer,
    policyChangeReq: HabitationalPolicyChangeReqReducer,
    policyform: HabitationalPolicyFormReducer,
    schedule: HabitationalPropertyScheduleReducer,
    addressHistory: AddressHistoryReducer,
    quote: HabitationalQuoteReducer,
  }),
  lifeInsurance: combineReducers({
    basicDetails: lifeInsuranceBasicDetailsReducer,
    policies: lifeInsurancePoliciesReducer,
    complianceCheckList: lifeInsuranceComplianceCheckListReducer,
    existingProperty: lifeInsurancePolicyExistingPropertyReducer,
    familyTree: lifeInsurancePolicyFamilyTreeReducer,
    coverageNeed: lifeInsuranceCoverageNeedReducer,
    riders: lifeInsuranceRidersReducer,
  }),

  userprofile: UserProfileReducer,
  common: commonReducer,
  tasks: combineReducers({
    allTasks: tasksReducer,
    calender: tasksCalenderReducer,
    generalChange: generalChangeReducer,
    paymentMethods: tasksPaymentMethodsReducer,
    urgentTransactions: taskUrgentTransactionsReducer,
    driver: taskDriverReducer,
    vehicle: taskVehicleReducer,
    garagePlate: taskGaragePlateReducer,
    interestedParty: taskInterestedPartyReducer,
    lessor: taskLessorReducer,
    riskLocation: taskRiskLocationReducer,
    taskBoard: tasksBoardReducer,
    notices: noticesReducer,
    oldBusinessTracker: oldBusinessTrackerReducer,
    oldInsurancReports: oldInsuranceReportsReducer,
    policyChangeRequest: policyChangeRequestReducer,
    certificateOfInsurance: certificateOfInsuranceReducer,
    vinDecoder: vinDecoderReducer,
  }),
  quote: quoteRequestReducer,
  opportunites: opportunitesReducer,
  leads: leadsReducer,
  leadApplications: leadApplicationsReducer,
  leadHabitationalApplication: leadHabitationalApplicationReducer,
  leadAutoApplication: leadAutoApplicationReducer,
  legals: legalsReducer,
  insuranceReports: insuranceReducer,
  binders: bindersReducer,
  allbinders: allBindersReducer,
  renewals: renewalsReducer,
  Marketings: MarketingsReducer,
  NewRemarketChange: NewRemarketReducer,

  //HR
  allApplications: applicationReducer,
  templates: templateReducer,

  security: securityReducer,

  //eDocs
  eDocs: eDocsReducer,
  policyNotes: notesReducer,

  //Accounting
  accounting: combineReducers({
    accountingCompanyInformation: AccountingCompanyInformationReducer,
    accountingTaxInformation: AccountingTaxInformationReducer,
    accountingGLAccounts: AccountingGLAccountsReducer,
    interacEmailTransfer: AccountingIInteracEmailTransferReducer,
    eft: AccountingEftReducer,
    receivable: AccountingReceivableReducer,
    companyDetail: AccountingCompanyDetailReducer,
    systemGLAccount: AccountingSystemGLAccountReducer,
    chartsOfAccounts: ChartsOfAccountsReducer,
    companyOnboarding: AccountingCompanyOnboardingReducer,
    taxInfo: AccountingTaxInfoReducer,
    transactions: AccountingTransactionsReducer,
    information: AccountingInformationReducer,
    invoiceInformation: AccountingInvoiceInformationReducer,
    reports: AccountingReportsReducer,
    bankAccount: AccountingBankAccountReducer,
    creditCard: AccountingCreditCardReducer,
    cheque: AccountingChequeReducer,
    accountsPayable: AccountingAccountsPayableReducer,
    recievableTrust: AccountingRecievableTrustReducer,
    paymentAccountsRecievable: AccountingPaymentAccountsRecievableReducer,
    paymentBulkAccountsRecievable: AccountingPaymentBulkAccountsRecievableReducer,
    accountsPayableCheque: AccountingAccountsPayableChequeReducer,
    vendor: AccountingVendorReducer,
    invoiceTemplate: AccountingInvoiceTemplateReducer,
    transactionType: AccountingTransactioTypeReducer,
    transactionDescription: AccountingTransactioDescriptionReducer,
    bill: AccountingBillReducer,
    billTemplate: AccountingBillTemplateReducer,
    billPaymentPayable: AccountingBillPaymentPayableReducer,
    tax: AccountingTaxReducer,
    generalLedger: GeneralLedgerReducer,
    accountingReports: CallAgencyBillorDirectReducer,
    customerStatement: customerStatementReportReducer,
    testOne: testOneReducer,
    testTwo: testTwoReducer,
    billTransactionType: AccountingBillTransactioTypeReducer,
    operatingStatements: operatingStatementsReducer,
    jeTypeAndEntry: AccountingJeTypeAndEntryReducer,
    balancesheetStatements: balanceSheetStatementsReducer,
    glAgingReport: glAgingReportReducer,
    fiscalPeriods: fiscalPeriodsReducer,
    glMonthlySummary: glMonthlySummaryReducer,
    glFiscalYearClose: glFiscalYearCloseReducer,
    seedBalances: seedBalancesReducer,
    glSummaryReconcile: glSummaryReconcileReducer,
    riboForms: RIBOFormsReducer,
    physicalDefaultCommission: AccountingPhysicalDefaultCommissionReducer,
    bankCreditDebit: bankCreditDebitReducer,
    trialBalance: TrialBalanceReducer,
    importBulkPaymentBill: importBulkPaymentBillReducer,
    recurringInvoice: RecurringInvoiceReducer,
  }),
  g4Sign: combineReducers({
    documents: g4SignDocumentsReducer,
  }),

  appForm: appFormReducer,
  supportTickets: supportTicketsReducer,
  emailStatistics: emailStatisticsReducer,
  utility: utilityReducer,
  csio: csioReducer,
  mpoi: mpoiReducer,
  controlLog: controlLogReducer,
  automation: automationReducer,
  emailSequences: emailSequencesReducer,
  sequenceContactLists: sequenceContactListsReducer,
  csioEdocs: csioEdocsReducer,
  acitivty: activityReducer,
  expressionTransformation: expressionTransformationReducer,
  csioCron: csioCronReducer,
  reconciliation: reconciliationReducer,
  envConfig: envConfigReducer,
  quoteConfig: QuoteSettingsReducer,
  subscriptionPlan: subscriptionPlanReducer,
  whatsappTemplate: whatsappTemplateReducer,
  quickReplyTemplate: quickReplyTemplateReducer,
  accountingDashbaord: AccountingDashboardReducer,
  csioEDI: csioEDIReducer,
  ediXmlTracking: ediXmlTrackingReducer,
  aiReconciliation: aiReconciliationReducer,
  policyCommon: policyCommonReducer,
  claims: claimsReducer,
  projects: aiProjectsReducer,
  userMapping: userMappingReducer,
  emails: emailsReducer,
  premiumComparison: premiumComparisonReducer,
  actionItems: actionItemReducer,
  orgEnvConfig: orgEnvConfigReducer,
  chatbot: chatbotReducer,
  masterDropdowns: MasterDropdownsReducer,
  buttonRoleVisibility: ButtonRoleVisibilityReducer,
  customFormFields: CustomFormFieldsReducer,
  myCommissionReports: myCommissionReportsReducer,
  myRenewals: myRenewalsReducer,
  notifications: notificationReducer,
  outlook: outlookReducer,
  aiChat: aiChatReducer,
  dashboard: dashboardReducer,
  operationalUpdates: operationalUpdatesReducer,
  signature: signatureReducer,
  accessLogs: accessLogsReducer,
  genAiKnowledgeBase: genAiKnowledgeBaseReducer,
  policyEmailCompose: policyEmailComposeReducer,
  globalMessages: globalMessagesReducer,
  requestedUserName: requestedUserNameReducer,
  changeHistory: changeHistoryReducer,
  plInsights: plInsightsReducer,
  dashboardSettings: dashboardSettingsReducer,
  phone: phoneReducer,
  mirtapbxCallLog: mirtapbxCallLogReducer,
  mirtapbxCallContext: mirtapbxCallContextReducer,
  genAi: genAiReducer,
  messageSequence: messageSequenceReducer,
  agentTools: agentToolsReducer,
  webrtc: webrtcReducer,
  pbsQuote: pbsQuoteReducer,
});

export const rootReducer = (state: IStoreState | undefined, action: any) => {
  if (action.type === "USER_LOGOUT") {
    return appReducer(undefined, action);
  } else if (action.type === "CLEAR_POLICY_STATE") {
    return appReducer(
      {
        ...state,
        business: { ...initialStoreState["business"] },
        automobile: { ...initialStoreState["automobile"] },
        commAuto: { ...initialStoreState["commAuto"] },
        habitational: { ...initialStoreState["habitational"] },
        lifeInsurance: {...initialStoreState["lifeInsurance"]},
      } as IStoreState,
      action
    );
  }
  return appReducer(state, action);
};
